module.exports = __webpack_public_path__ + "img/cert2.16c806bc.jpg";